import DataTypes from './DataTypes'
import MeasurementUnits from './MeasurementUnits'

export default {
  // default units
  [DataTypes.TEMPERATURE]: '°C',
  [DataTypes.HUMIDITY]: '%',
  [DataTypes.CO2]: 'ppm',
  [DataTypes.FORMALDEHYDE]: 'µg/m³',
  [DataTypes.VOCS]: 'ppb',
  [DataTypes.VOCS_INDEX]: 'Index',
  [DataTypes.PM25]: 'µg/m³',
  [DataTypes.PM10]: 'µg/m³',
  [DataTypes.PM4]: 'µg/m³',
  [DataTypes.PM1]: 'µg/m³',
  [DataTypes.CO]: 'ppm',
  [DataTypes.O3]: 'ppb',
  [DataTypes.NO2]: 'ppb',
  [DataTypes.LIGHT]: 'lux',
  [DataTypes.NOISE]: 'dB',

  [DataTypes.RADIANT_TEMPERATURE]: '°C',
  [DataTypes.RADON]: 'Bq/m³',
  [DataTypes.NOX]: '',
  [DataTypes.CAPACITY]: 'pax',
  [DataTypes.NH3]: 'µg/m³',
  [DataTypes.NO]: 'µg/m³',
  [DataTypes.SO2]: 'µg/m³',

  [DataTypes.COVID_19]: '',
  [DataTypes.THERMAL_INDICATOR]: '',
  [DataTypes.MOLD_INDICATOR]: '',
  [DataTypes.IAQ]: '',
  [DataTypes.VENTILATION_INDICATOR]: '',
  [DataTypes.GO_IAQS]: '',
  [DataTypes.GO_IAQS_DOMINANT]: '',

  // Oher units
  [MeasurementUnits.CELSIUS]: '°C',
  [MeasurementUnits.KELVIN]: 'K',
  [MeasurementUnits.FAHRENHEIT]: '°F',

  [MeasurementUnits.VOCS_INDEX]: 'Index',
  [MeasurementUnits.VOCS_UG_WELL]: 'µg/m³',
  [MeasurementUnits.VOCS_UG_RESET]: 'µg/m³',
  [MeasurementUnits.VOCS_PPB]: 'ppb',

  [MeasurementUnits.FORMALDEHYDE_UG]: 'µg/m³',
  [MeasurementUnits.FORMALDEHYDE_PPB]: 'ppb',

  [MeasurementUnits.O3_PPB]: 'ppb',
  [MeasurementUnits.O3_UG]: 'µg/m³',

  [MeasurementUnits.CO_UG]: 'µg/m³',
  [MeasurementUnits.CO_PPM]: 'ppm',
  [MeasurementUnits.CO_MG]: 'mg/m³',
  [MeasurementUnits.CO_UG]: 'µg/m³',

  [MeasurementUnits.NO2_PPB]: 'ppb',
  [MeasurementUnits.NO2_UG]: 'ug/m³',

  [MeasurementUnits.PM10_MG]: 'mg/m³',
  [MeasurementUnits.PM25_MG]: 'mg/m³',
  [MeasurementUnits.PM1_MG]: 'mg/m³',
  [MeasurementUnits.PM4_MG]: 'mg/m³',

  [MeasurementUnits.PM10_UG]: 'µg/m³',
  [MeasurementUnits.PM25_UG]: 'µg/m³',
  [MeasurementUnits.PM1_UG]: 'µg/m³',
  [MeasurementUnits.PM4_UG]: 'µg/m³'
}
